import { atom } from '@zedux/react'

const galleryImagesAtom = atom("galleryImagesAtom", [])

export default galleryImagesAtom